<div [hidden]="coverSet" class="img-container">
  <img #image [src]="imageSource" crossorigin />
</div>
<img *ngIf="coverSet" [src]="imageDestination" class="img-preview" />
<div *ngIf="!coverSet" class="image__cropper__footer text-right mb-3">
  <button
    type="button"
    class="button button--borderless button--small"
    (click)="reset()"
    translate
  >
    Reset
  </button>
  <button
    type="button"
    class="button button--purple button--small"
    (click)="setCoverImage()"
    translate
  >
    Done
  </button>
</div>
<!-- <div *ngIf="multipleImages" class="image__cropper__footer text-right mb-3">
  <button type="button" class="button button--borderless button--small">
    Reset
  </button>
  <button
    type="button"
    class="button button--purple button--small"
    (click)="addToGallery($event)"
  >
    Done
  </button>
</div> -->
<!-- <div *ngIf="multipleImages && galleryImages" class="cropped__images__wrapper">
  <div *ngFor="let gallery of galleryImages; index as i" class="cropped__image">
    <img src="{{ gallery.image }}" />
    <div class="cropped__image__overlay">
      <h3>Remove</h3>
    </div>
  </div>
</div> -->
